export default __webpack_public_path__ + "static/media/eurocrisis.1fb57632.jpg";